module.exports = "<div class=\"mission-objective custom-control custom-checkbox\">\n  <input id=\"rubber_band\" class=\"objective-checkbox form-check-input custom-control-input\" data-bind-target=\"objective-checkbox\" type=\"checkbox\">\n  <label for=\"rubber_band\" class=\"objective-label custom-control-label\" data-bind-target=\"objective-name\"></label>\n  <!--<input type=\"number\" class=\"form-control objective-amount\" data-bind-target=\"objective-count\" name=\"quantity\" min=\"1\" max=\"999\" placeholder=\"1\"> -->\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./app/views/partials/objectives/mission-objective.html
// module id = 264
// module chunks = 1